import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';
import { CreatePurchaseRequestInput, UpdatePurchaseRequestInput } from '@/types/purchase-request';

export default function purchaseRequest(axios: any) {
  async function getPurchaseRequests(filter: any) {
    try {
      const response = await axios.get(`/api/purchase_requests?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] getPurchaseRequests Error', e);
    }
    return null;
  }

  async function getPurchaseRequest(id: number) {
    const response = await axios.get(`/api/purchase_requests/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] getPurchaseRequest Error', e);
    }
    return null;
  }

  async function createPurchaseRequest(payload: CreatePurchaseRequestInput) {
    const response = await axios.post('/api/purchase_requests', camelObjectToSnakeObject(payload, ['itemsType', 'dueDate', 'miscItems', 'subType']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/purchase-request] createPurchaseRequest Error', e);
    }
    return null;
  }

  async function approvePurchaseRequest(id: number) {
    const response = await axios.post(`api/purchase_requests/${id}/approve`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/purchase-request] approvePurchaseRequest Error', e);
    }
    return null;
  }

  async function updatePurchaseRequest(id: number, payload: UpdatePurchaseRequestInput) {
    const response = await axios.put(`/api/purchase_requests/${id}`, camelObjectToSnakeObject(payload, ['itemsType', 'dueDate', 'miscItems', 'subType']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/purchase-request] updatePurchaseRequest Error', e);
    }
    return null;
  }

  async function getPurchaseRequestItems(filter: any) {
    const response = await axios.get(`/api/purchase_request_items?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] getPurchaseRequestItems Error', e);
    }
    return null;
  }

  async function getPurchaseRequestMiscItems(filter: any) {
    const response = await axios.get(`/api/purchase_request_misc_items?${filterValueToQuery(filter)}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] getPurchaseRequestItems Error', e);
    }
    return null;
  }

  async function searchPurchaseRequestItems(payload: any, type = 'purchase_request_items') {
    const response = await axios.post(`/api/${type}/search`, payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] searchPurchaseRequestItems Error', e);
    }
    return null;
  }

  async function receivePurchaseRequest(payload: any) {
    const response = await axios.post('/api/purchase_requests/receive', payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] receivePurchaseRequest Error', e);
    }
    return null;
  }

  async function getPurchaseRequestStats() {
    const response = await axios.get('/api/purchase_requests/stats');
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/purchase-request] getPurchaseRequestStats Error', e);
    }
    return null;
  }

  return {
    getPurchaseRequests,
    getPurchaseRequest,
    createPurchaseRequest,
    approvePurchaseRequest,
    updatePurchaseRequest,
    getPurchaseRequestItems,
    getPurchaseRequestMiscItems,
    searchPurchaseRequestItems,
    getPurchaseRequestStats,

    receivePurchaseRequest,
  };
}
